'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { DSK_QUICK_BUTTONS_CONFIG } from '../../config/dskQuickButtons';

/**
 * ДСК `pay-buttons.js` (23 KB, `Cache-Control: max-age=0` → тегли се при всяко
 * зареждане) създава `window.payButtonsWidget`, който се ползва единствено от
 * `DSKQuickButtonsWidget` — тоест само в плащането. Досега скриптът стоеше в root
 * layout-а и се дърпаше на ВСЯКА страница, включително началната, където нищо не
 * го вика (Lighthouse 2026-08-29: 23 KB + main-thread работа за нула полза).
 *
 * Скриптът не отпада — просто се зарежда там, където се ползва.
 *
 * `/checkout` минава през rewrite към `/pages/checkout` (next.config.mjs), а
 * payment страниците нямат rewrite и живеят на `/pages/payment/*`. `usePathname()`
 * връща URL-а от адресната лента (`/checkout`), но при SSR/директно отваряне може
 * да е вътрешният път — затова се разпознават и двата варианта.
 */
const PAYMENT_PATH_PATTERN = /^\/(?:pages\/)?(?:checkout|payment)(?:\/|$)/;

export function isPaymentPath(pathname) {
  return typeof pathname === 'string' && PAYMENT_PATH_PATTERN.test(pathname);
}

export default function PaymentScript() {
  const pathname = usePathname();

  if (!isPaymentPath(pathname)) {
    return null;
  }

  return (
    <Script id="pay-buttons" src={DSK_QUICK_BUTTONS_CONFIG.scriptUrl} strategy="afterInteractive" />
  );
}
